import { validarPayload } from './remote-config.schema';
import { IRemoteConfigPayload } from './remote-config.types';

/**
 * Mesmo prefixo do LocalStorageService (`treino/`), para que o sufixo apareça em
 * `keysToPreserve` de `clearAllData()`. Sem isso, todo logout apagaria o cache e
 * empurraria o launch seguinte para o caminho bloqueante — preso na tela de
 * erro, se o usuário estivesse offline nesse momento.
 */
export const CHAVE_CACHE = 'treino/remote-config:v1';

/**
 * Em WebView de app e com dados de site bloqueados, até LER a propriedade
 * `window.localStorage` lança SecurityError (DOMException 18) — não só o
 * getItem. É a mesma guarda que LocalStorageService aplica; aqui ela é
 * duplicada porque este código roda antes do bootstrap, sem acesso à DI.
 */
function armazenamento(): Storage | null {
  if (typeof window === 'undefined') return null;
  try {
    const storage = window.localStorage;
    storage.getItem(CHAVE_CACHE);
    return storage;
  } catch {
    return null;
  }
}

/**
 * O que sai daqui já passou pelo schema e pela allowlist. O cache é entrada não
 * confiável como qualquer outra: pode vir truncado de uma escrita interrompida,
 * ou adulterado num aparelho com root.
 */
export function lerCache(): IRemoteConfigPayload | null {
  try {
    const bruto = armazenamento()?.getItem(CHAVE_CACHE);
    if (!bruto) return null;

    const conteudo: unknown = JSON.parse(bruto);
    return validarPayload(conteudo) ? conteudo : null;
  } catch {
    return null;
  }
}

/** Falha de escrita não pode derrubar o boot: sem cache, o próximo launch busca de novo. */
export function gravarCache(payload: IRemoteConfigPayload): void {
  try {
    armazenamento()?.setItem(CHAVE_CACHE, JSON.stringify(payload));
  } catch {
    // Cota estourada ou acesso revogado no meio da sessão.
  }
}
